<ion-header
  class="ion-no-border"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-header-modal-desktop'
      : platform === platformRef.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label data-cy="dual-pane-modal-title" class="title-bold">
      <ion-icon
        data-cy="pim-modal-back-button"
        class="go-back"
        src="../../../../../assets/icon/chevron-left.svg"
        (click)="goBack()"
      ></ion-icon>
      {{ title | translate }}
    </ion-label>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        class="forward"
        data-cy="pim-selection-close-modal-button"
        (click)="dismiss()"
      >
        <ion-icon
          data-cy="pim-selection-close-modal-button-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
  scroll-y="false"
>
  <ion-grid>
    <ion-row>
      <ion-col [size]="12">
        <ng-container>
          <ion-searchbar
            data-cy="radio-searchbar"
            class="search"
            mode="md"
            placeholder="{{ searchPlaceholder | translate }}"
            [(ngModel)]="searchKey"
            (ionClear)="resetSearch()"
            (ionInput)="handleSearch()"
          >
          </ion-searchbar>
          <div
            class="no-results-found"
            *ngIf="searchableHeirarchyData?.length === 0"
          >
            {{ 'i18n.lists.copyListModal.noResultsFound' | translate }}
          </div>

          <ion-radio-group
            *ngIf="searchableHeirarchyData?.length > 0"
            name="radio-selection"
            value="{{ selection?.code }}"
            (ionChange)="handleRadioSelection($event)"
            allowEmptySelection
          >
            <ion-item-divider
              *ngIf="searchableHeirarchyData?.length > 0"
              class="clamp-height"
            >
            </ion-item-divider>
            <ion-item
              *ngFor="let radioItem of searchableHeirarchyData"
              class="single-select-item"
            >
              <ion-radio
                mode="md"
                labelPlacement="start"
                value="{{ radioItem.code }}"
                data-cy="pim-radio"
                class="single-select-radio radio-label"
              >
                <div class="radio-label">
                  {{ radioItem.description }}
                </div>
              </ion-radio>
            </ion-item>
          </ion-radio-group>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === platformRef.desktop"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="pim-selection-cancel-button"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="goBack()"
      >
        {{ 'i18n.common.back' | translate }}
      </ion-button>

      <ion-button
        data-cy="pim-selection-next-button"
        [ngClass]="
          initialSelection?.code === selection?.code ||
          (selection === undefined && initialSelection === undefined)
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="onSave()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
